/**
 * POSITREX
 * @desc main entry webpack bundle file
 * @author Radim Kolar
 */

// "use strict";

import $ from 'jquery';
import {
	defaultCallback,
	defaultErrCallback,
	defaultJsonCallback,
	forceReloadPage,
	jsonMessageBoxCallback,
	modalTabSubmitCallback,
	pageResponse,
	placeResponse,
	setReadyForExport,
} from "./main_callbacks";
import {
	actionCall,
	addSession,
	alignDropdown,
	appendData,
	callUrl,
	charts,
	clearDelay,
	clearRefresh,
	clearRefreshArr,
	confirmedAction,
	createServerInfo,
	delay,
	fixedFilter,
	formatGps,
	fullHeight,
	getCookie,
	getMsg,
	setMsg,
	getSession,
	getUrl,
	handlePanels,
	handleResellerClientSelect,
	initBatchActionCall,
	initCheckGroup,
	initChosen,
	initColorPicker,
	initComponents,
	initEnter,
	initMobileMenu,
	initModal,
	initSavingCollapseById,
	initSendSmsLink,
	initShowAllChild,
	initShowChild,
	initShowModal,
	initSummaryComponents,
	interval,
	isDesktop,
	isPortrait,
	isMobile,
	isRtl,
	move,
	moveEnd,
	openPtx,
	openWithParams,
	parseFloatNumber,
	refresh,
	refreshArr,
	reloadContent,
	reloadContentAll,
	removeDom,
	removeSession,
	showUnfoldSubRowsBtn,
	showHideSubRowsBtn,
	selectColor,
	selectIfOnlyOne,
	setCookie,
	setSelectItems,
	setSession,
	showHideAllChild,
	showHideChild,
	TINYMCE_CONFIG,
	downloadFile,
} from "./main_ptx";
import {
	addRemoteTab,
	addTab,
	currentTabId,
	initRemoteTabLoad,
	initTab,
	removeTab,
	showTab,
	tabSubmitForm,
} from "./main_tabs";
import {
	_alert,
	_confirm,
	_error,
	_prompt,
	_warning,
	captionSlide,
	fullScreen,
	getBorderColor,
	handleCookies,
	handleSearchBox,
	initTooltips,
	initTaxRecalc,
	parseFloatLocalized,
	isMenuTooBig,
	leftSlider,
	logout,
	message,
	now,
	post,
	rebaseMenu,
	resizeToBottomCorner,
	showAllChild,
	showChild,
	showLoading,
	toggleAllCheckbox
} from "./main";
import {removeErrors, submit, selectSort, submitCurrent, initializeDropzone} from "./main_form";
import {btn, formWithSim, icon, msg, resolvAddressBox, smsCommands, tracePlanButton} from "./main_html";
import {createCharts} from "./main_charts";
import {getLocale, localeDatepicker} from "./main_locale";
import {initCopyToClipboard} from "./main_misc";
import {
	draggable,
	handleClose,
	handleShow,
	hideCurrent,
	initForm,
	initialize,
	show,
	submitForm
} from "./main_modal";
import {registerModule} from "./main_module";
import {
	contentSel,
	filter,
	filterSel,
	findPageFromSection,
	getFilter,
	initCommon,
	initFilter,
	mainSel,
	openPage,
	openUrl,
	reloadCurrent,
	sendWithFilter,
	unloadCommon
} from "./main_page";
import {bulkResolve, getUnitAddress, msgResolve, replaceMsg} from "./main_resolver";
import {execFunction, getFunction, unloadGoogleMapsApi} from "./main_system";
import {
	calculateAverageColumnWidth,
	calculateMaxColumnWidth,
	drawMap,
	drawSummary,
	drawUniversal,
	fillGroupFilter,
	fixedStickyHeadersInModal,
	getBattery,
	groupOptions,
	initChangeUnitIgnition,
	initGroupFilter,
	initIgnition,
	initMap,
	initStickyHeaders,
	initSummary,
	initTableHeader,
	initTables,
	initToggleStatTable,
	initUniversal,
	maintenance,
	mapColSettings,
	onSort,
	renderStatus,
	showTablesByGroupFilter,
	statusCounter,
	stickyHeadersOverflowInModal,
	summaryColSettings,
	updateMinHeight
} from "./main_tables";
import {
	BaseMap,
	MAP_TYPE_EDIT_GZ,
	MAP_TYPE_EDIT_POI,
	MAP_TYPE_EOD,
	MAP_TYPE_LOGBOOK,
	MAP_TYPE_MAIN,
	MAP_TYPE_SIMPLE,
	MAP_TYPE_TRACE,
	MAP_TYPE_TRACE_ANALYZE,
	unitTableSelector
} from "./map/map_base";
import {GoogleMap} from "./map/map_google";
import {GoogleMapEdit} from "./map/map_google_edit";
import {LeafletMap} from "./map/map_leaflet";
import {LeafletMapEdit} from "./map/map_leaflet_edit";
import {
	defineMap,
	LeafletMap_CZSK,
	LeafletMap_WORLD,
	LeafletMapEdit_CZSK,
	LeafletMapEdit_WORLD
} from "./map/map_defs";

window.jQuery = window.$ = $;


/** @namespace */
Ptx = Ptx || {}
Ptx.modules = Ptx.modules || {};
Ptx.fullScreen = fullScreen;
Ptx.captionSlide = captionSlide;
Ptx.leftSlider = leftSlider;
Ptx.initTaxRecalc = initTaxRecalc;
Ptx.parseFloatLocalized = parseFloatLocalized;
Ptx.resizeToBottomCorner = resizeToBottomCorner;
Ptx.showLoading = showLoading;
Ptx.showAllChild = showAllChild;
Ptx.showChild = showChild;
Ptx.warning = _warning;
Ptx.error = _error;
Ptx.message = message;
Ptx.alert = _alert;
Ptx.confirm = _confirm;
Ptx.prompt = _prompt;
Ptx.isMenuTooBig = isMenuTooBig;
Ptx.isHeadlessChromeAccess = false;
Ptx.rebaseMenu = rebaseMenu;
Ptx.getBorderColor = getBorderColor;
Ptx.toggleAllCheckbox = toggleAllCheckbox;
Ptx.handleCookies = handleCookies;
Ptx.handleSearchBox = handleSearchBox;
Ptx.handlePanels = handlePanels;
Ptx.post = post;
Ptx.logout = logout;
Ptx.now = now;
Ptx.getMsg = getMsg;
Ptx.setMsg = setMsg;

/** @namespace */
Ptx.form = Ptx.form || {};
Ptx.form.submit = submit;
Ptx.form.submitCurrent = submitCurrent;
Ptx.form.removeErrors = removeErrors;

/** @namespace */
Ptx.html = Ptx.html || {};
Ptx.html.btn = btn;
Ptx.html.formWithSim = formWithSim;
Ptx.html.msg = msg;
Ptx.html.icon = icon;

Ptx.html.resolvAddressBox = resolvAddressBox;
Ptx.html.smsCommands = smsCommands;
Ptx.html.tracePlanButton = tracePlanButton;

/** @namespace */
Ptx.locale = Ptx.locale || {};
Ptx.locale.datepicker = localeDatepicker;
Ptx.locale.getLocale = getLocale;

/** @namespace */
Ptx.fn = Ptx.fn || {};
Ptx.fn.initCopyToClipboard = initCopyToClipboard;

/** @namespace */
Ptx.modal = Ptx.modal || {};
Ptx.modal.form = Ptx.modal.form || {};
Ptx.modal.history = Ptx.modal.history || {};
Ptx.modal.show = show;
Ptx.modal.initModal = initialize;
Ptx.modal.handleShow = handleShow;
Ptx.modal.handleClose = handleClose;
Ptx.modal.draggable = draggable;
Ptx.modal.hideCurrent = hideCurrent;
Ptx.modal.form.init = initForm;
Ptx.modal.form.submitCurrent = submitForm;
Ptx.modal.lowerModal = Ptx.modal.lowerModal || {};
Ptx.modal.refreshOnClose = false;
Ptx.modal.disableAnimation = false;

/** @namespace */
Ptx.module = Ptx.module || {};
Ptx.module.register = registerModule;

/** @namespace */
Ptx.page = Ptx.page || {};
Ptx.page.mainSel = mainSel;
Ptx.page.contentSel = contentSel;
Ptx.page.filterSel = filterSel;
Ptx.page.filter = filter;
Ptx.page.sendWithFilter = sendWithFilter;
Ptx.page.openUrl = openUrl;
Ptx.page.getFilter = getFilter;
Ptx.page.reloadCurrent = reloadCurrent;
Ptx.page.unloadCommon = unloadCommon;
Ptx.page.initCommon = initCommon;
Ptx.page.initFilter = initFilter;
Ptx.page.open = openPage;
Ptx.page.findPageFromSection = findPageFromSection;

/** @namespace */
Ptx.url = getUrl;
Ptx.fn.initShowModal = initShowModal;
Ptx.fn.initModal = initModal;
Ptx.fn.initTooltips = initTooltips;
Ptx.fn.callUrl = callUrl;
Ptx.fn.appendData = appendData;
Ptx.fn.removeDom = removeDom;
Ptx.fn.initSummaryComponents = initSummaryComponents;
Ptx.fn.initComponents = initComponents;
Ptx.fn.alignDropdown = alignDropdown;
Ptx.fn.charts = charts;
Ptx.fn.createCharts = createCharts;
Ptx.fn.initBatchActionCall = initBatchActionCall;
Ptx.fn.actionCall = actionCall;
Ptx.fn.confirmedAction = confirmedAction;
Ptx.fn.initColorPicker = initColorPicker;
Ptx.fn.initShowAllChild = initShowAllChild;
Ptx.fn.initShowChild = initShowChild;
Ptx.fn.initializeDropzone = initializeDropzone;
Ptx.fn.showHideAllChild = showHideAllChild;
Ptx.fn.showHideChild = showHideChild;
Ptx.fn.initSendSmsLink = initSendSmsLink;
Ptx.fn.showHideSubRowsBtn = showHideSubRowsBtn;
Ptx.fn.showUnfoldSubRowsBtn = showUnfoldSubRowsBtn;
Ptx.fn.getSession = getSession;
Ptx.fn.addSession = addSession;
Ptx.fn.setSession = setSession;
Ptx.fn.removeSession = removeSession;
Ptx.fn.setCookie = setCookie;
Ptx.fn.getCookie = getCookie;
Ptx.fn.reloadContentAll = reloadContentAll;
Ptx.fn.reloadContent = reloadContent;
Ptx.fn.initChosen = initChosen;
Ptx.fn.initSavingCollapseById = initSavingCollapseById;
Ptx.fn.initMobileMenu = initMobileMenu;
Ptx.fn.openWithParams = openWithParams;
Ptx.fn.openPtx = openPtx;
Ptx.fn.initCheckGroup = initCheckGroup;
Ptx.fn.initToggleStatTable = initToggleStatTable;
Ptx.fn.interval = interval;
Ptx.fn.delay = delay;
Ptx.fn.clearDelay = clearDelay;
Ptx.fn.refresh = refresh;
Ptx.fn.clearRefresh = clearRefresh;
Ptx.fn.refreshArr = refreshArr;
Ptx.fn.clearRefreshArr = clearRefreshArr;
Ptx.fn.createServerInfo = createServerInfo;
Ptx.fn.selectColor = selectColor;
Ptx.fn.fullHeight = fullHeight;
Ptx.fn.isMobile = isMobile;
Ptx.fn.isDesktop = isDesktop;
Ptx.fn.isPortrait = isPortrait;
Ptx.fn.isRtl = isRtl;
Ptx.fn.selectIfOnlyOne = selectIfOnlyOne;
Ptx.fn.move = move;
Ptx.fn.moveEnd = moveEnd;
Ptx.fn.initEnter = initEnter;
Ptx.fn.fixedFilter = fixedFilter;
Ptx.fn.parseFloat = parseFloatNumber;
Ptx.fn.formatGps = formatGps;
Ptx.fn.selectSort = selectSort;
Ptx.fn.setReadyForExport = setReadyForExport;
Ptx.fn.setSelectItems = setSelectItems;
Ptx.fn.handleResellerClientSelect = handleResellerClientSelect;
Ptx.fn.downloadFile = downloadFile;

/** @namespace */
Ptx.resolver = Ptx.resolver || {};
Ptx.resolver.bulkResolve = bulkResolve;
Ptx.resolver.msgResolve = msgResolve;
Ptx.resolver.replaceMsg = replaceMsg;
Ptx.resolver.getUnitAddress = getUnitAddress;

/** @namespace */
Ptx.sys = Ptx.sys || {};
Ptx.sys.getFunction = getFunction;
Ptx.sys.execFunction = execFunction;
Ptx.sys.unloadGoogleMapsApi = unloadGoogleMapsApi;

/** @namespace */
Ptx.tables = Ptx.tables || {};
Ptx.tables.summary = Ptx.tables.summary || {};
Ptx.tables.complete = Ptx.tables.complete || function (that) {};
Ptx.tables.afterInit = Ptx.tables.afterInit || function (table) {};
Ptx.tables.defaultSearch = "";
Ptx.tables.groupOptions = groupOptions;
Ptx.tables.summary.colSettings = summaryColSettings;
Ptx.tables.summary.searchCol = [];
Ptx.tables.summary.groupId = 0;
Ptx.tables.summary.groupFilter = 0;
Ptx.tables.summary.refreshTimeInSeconds = 0;
Ptx.tables.summary.col = [];
Ptx.tables.summary.order = [];
Ptx.tables.summary.data = {};
Ptx.tables.summary.getBattery = getBattery;
Ptx.tables.summary.maintenance = maintenance;
Ptx.tables.summary.init = initSummary;
Ptx.tables.summary.draw = drawSummary;
Ptx.tables.summary.statusCounter = statusCounter;
Ptx.tables.renderStatus = renderStatus;
Ptx.tables.map = Ptx.tables.map || {};
Ptx.tables.map.init = initMap;
Ptx.tables.map.draw = drawMap;
Ptx.tables.map.col = [];
Ptx.tables.map.order = [];
Ptx.tables.map.data = {};
Ptx.tables.map.visibleUnits = [];
Ptx.tables.map.notVisibleUnits = [];
Ptx.tables.map.colSettings = mapColSettings;
Ptx.tables.universal = Ptx.tables.universal || {};
Ptx.tables.universal.init = initUniversal;
Ptx.tables.universal.draw = drawUniversal;
Ptx.tables.universal.col = [];
Ptx.tables.universal.order = [];
Ptx.tables.universal.data = {};
Ptx.tables.init = initTables;
Ptx.tables.calculateAverageColumnWidth = calculateAverageColumnWidth;
Ptx.tables.calculateMaxColumnWidth = calculateMaxColumnWidth;
Ptx.tables.summary.fillGroupFilter = fillGroupFilter;
Ptx.tables.summary.initGroupFilter = initGroupFilter;
Ptx.tables.summary.showTablesByGroupFilter = showTablesByGroupFilter;
Ptx.tables.stickyHeadersOverflowInModal = stickyHeadersOverflowInModal;
Ptx.tables.fixedStickyHeadersInModal = fixedStickyHeadersInModal;
Ptx.tables.onSort = onSort;
Ptx.tables.initIgnition = initIgnition;
Ptx.tables.initChangeUnitIgnition = initChangeUnitIgnition;
Ptx.tables.initStickyHeaders = initStickyHeaders;
Ptx.tables.initTableHeader = initTableHeader;
Ptx.tables.updateMinHeight = updateMinHeight;

/** @namespace */
Ptx.fn.addTab = addTab;
Ptx.fn.addRemoteTab = addRemoteTab;
Ptx.fn.removeTab = removeTab;
Ptx.fn.showTab = showTab;
Ptx.fn.initRemoteTabLoad = initRemoteTabLoad;
Ptx.fn.initTab = initTab;
Ptx.fn.tabSubmitForm = tabSubmitForm;
Ptx.fn.currentTabId = currentTabId;

/** @namespace */
Ptx.page.placeResponse = placeResponse;
Ptx.page.pageResponse = pageResponse;
Ptx.fn.jsonMessageBoxCallback = jsonMessageBoxCallback;
Ptx.fn.defaultJsonCallback = defaultJsonCallback;
Ptx.modal.form.defaultCallback = defaultCallback;
Ptx.modal.modalTabSubmitCallback = modalTabSubmitCallback;
Ptx.fn.defaultErrCallback = defaultErrCallback;
Ptx.fn.forceReloadPage = forceReloadPage;

/** @namespace */
Ptx.settings = Ptx.settings || {};
Ptx.settings.tinymce = TINYMCE_CONFIG;

/** @namespace */
Ptx.maps = Ptx.maps || {};
Ptx.maps.TYPE_MAIN = MAP_TYPE_MAIN;
Ptx.maps.TYPE_LOGBOOK = MAP_TYPE_LOGBOOK;
Ptx.maps.TYPE_EDIT_POI = MAP_TYPE_EDIT_POI;
Ptx.maps.TYPE_EDIT_GZ = MAP_TYPE_EDIT_GZ;
Ptx.maps.TYPE_SIMPLE = MAP_TYPE_SIMPLE;
Ptx.maps.TYPE_TRACE = MAP_TYPE_TRACE;
Ptx.maps.TYPE_TRACE_ANALYZE = MAP_TYPE_TRACE_ANALYZE;
Ptx.maps.TYPE_EOD = MAP_TYPE_EOD;
Ptx.maps.unitTableSelector = unitTableSelector;
Ptx.maps.BaseMap = BaseMap;
Ptx.maps.Google = GoogleMap;
Ptx.maps.GoogleEdit = GoogleMapEdit;
Ptx.maps.OSM = LeafletMap;
Ptx.maps.OSM.defineMap = defineMap;
Ptx.maps.OSMEdit = LeafletMapEdit;
Ptx.maps.OSM_CZSK = LeafletMap_CZSK;
Ptx.maps.OSM_CZSKEdit = LeafletMapEdit_CZSK;
Ptx.maps.OSM_WORLD = LeafletMap_WORLD;
Ptx.maps.OSM_WORLDEdit = LeafletMapEdit_WORLD;